import "../../scss/bookkeeping-styling-component/pricing-plan.style.scss";
import { PricingCard } from "./pricing-card.component";
import { useTranslation } from "react-i18next";
import {plans} from "./../../constant/book-keeping.constant";

export const PricingPlans = ({navigateToRoute}: {navigateToRoute: (EnglishPath: string, swedishPath: string) => void}) => {
  const { t } = useTranslation();
  return (
    <div className="pricing-section">
      <div className="pricing-heading">
        <h2>{t("CHOOSE_YOUR_PACKAGE")}</h2>
        <p>{t("PACKAGE_NOTE")}</p>
      </div>
      <div className="pricing-plans-wrapper">
        {plans.map((plan, idx) => (
          <PricingCard key={idx} {...plan} onClick={() => navigateToRoute("contact-us", "kontakta-oss")}  />
        ))}
      </div>
    </div>
  );
};
